import { createFileRoute } from "@tanstack/react-router";
import { DebugHome } from "@/pages/3d/debug/DebugHome";

export const Route = createFileRoute("/demo/3d/debug/")({
  component: DebugHome,
});
